export default class AIMessagePackage {

    constructor(gameController, aiParent, execute=false) {
        this.gameController = gameController;
        this.aiParent = aiParent;
        this.startTime= performance.now();
        this.endTime= null;
        this.name= 'Captain';
        this.intentionLevels = [null, 2, 2, 2, 2, 2, 2];  // captain

        let actionPreferences = [1, 2, 3, 4, 5, 6];
        for (let i = 0; i < this.gameController.gamePlayerData.captain - 1; i++) {
            actionPreferences.push(actionPreferences.shift());
        }
        this.actionPreferences = actionPreferences;

        this.category= '';
        this.message= '';
        this.provenance= [];
        this.complete= false;
        this.success= false;
        this.execute= execute;
        this.clockedOutStaff = [];
        this.data= {}
    }

    addToMessage = (message) => {
        if (this.message) {
            this.message += ' and ';
        }
        this.message += message;
    }

    addProvenance = (question, answer, reason=null) => {
        let newAnswer;
        if (typeof(answer) === 'boolean') {
            newAnswer = answer ? 'Yes' : 'No';
        } else {
            newAnswer = answer;
        }
        this.provenance.push(
            {question: question, answer: newAnswer, reason: reason}
        )
    }
    done = () => {
        let delta =performance.now() - this.startTime;
        delta = Math.round((delta + Number.EPSILON) * 100) / 100
        this.provenance.push(
            {question: 'How quickly did I figure this out?',
                answer: `${delta} seconds.`,
                reason: 'Inquiring minds want to know.'}
        )
        this.message += '.';
        if (this.message === '.') {
            console.error('Stop, what am I doing?')
        }
    }

}
